import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["platform", "select"];
  static values = { options: Object };

  platformChanged() {
    const platform = this.platformTarget.value;
    const months = this.optionsValue[platform] || [];
    const currentValue = this.selectTarget.value;

    // Preserve the blank "Auto-detect" option
    const blankOption = this.selectTarget.querySelector('option[value=""]');

    // Remove all options using DOM methods
    while (this.selectTarget.firstChild) {
      this.selectTarget.removeChild(this.selectTarget.firstChild);
    }

    if (blankOption) this.selectTarget.append(blankOption);

    for (const m of months) {
      const opt = document.createElement("option");
      opt.value = m;
      opt.textContent = `${m} ${m === 1 ? "month" : "months"}`;
      if (String(m) === currentValue) opt.selected = true;
      this.selectTarget.append(opt);
    }
  }
}
